import { forwardRef } from 'react';
import { Search } from 'lucide-react';
import { ICON_SIZE, Input } from '../..';
import './SearchField.css';

const SearchField = forwardRef(({ label, className = '', ...props }, ref) => {
  if (!label) throw new Error('SearchField requires an accessible label.');
  return (
    <div className={`rds-search-field ${className}`.trim()}>
      <Search size={ICON_SIZE.md} aria-hidden="true" />
      <Input variant="quiet" {...props} ref={ref} type="search" aria-label={label} />
    </div>
  );
});
SearchField.displayName = 'SearchField';
export default SearchField;
